export function sendPageview(url) {
  if (typeof ga === 'function') {
    ga("send", "pageview", url)
  }
}
export function sendEvent(category, action, label = undefined, value = undefined) {
  if (typeof ga === 'function') {
    ga("send", "event", category, action, label, value)
  }
}
